import type {NextPage} from 'next';
import {useState} from 'react';
const ExploreLocation: NextPage = () => {
	const [openTab, setOpenTab] = useState(1);
	return (
		<>
			<section className='pt-[120px] pb-[60px] sm:pt-[180px] sm:pb-[100px] lg:pt-[180px] lg:pb-[120px]'>
				<div className='innerDiv mx-auto'>
					<div className='text-center mb-14'>
						<h2 className='text-3xl font-medium text-black mb-4'>Our locations</h2>
						<p className='text-lg'>Large or small, each one of our offices is designed to inspire innovation, big ideas, and community.</p>
					</div>
					<>
						<div className='flex flex-wrap'>
							<div className='w-full'>
								<ul className='flex mb-0 list-none flex-wrap pt-3 pb-4 flex-row justify-center' role='tablist'>
									<li className='text-center'>
										<a
											className={'font-medium uppercase px-5 py-1 inline-block leading-normal ' + (openTab === 1 ? 'text-black  border-blue-500 border-b-2' : 'text-black')}
											onClick={(e) => {
												e.preventDefault();
												setOpenTab(1);
											}}
											data-toggle='tab'
											href='#link1'
											role='tablist'>
											Center
										</a>
									</li>
									<li className='text-center'>
										<a
											className={'font-medium uppercase px-5 py-1 inline-block leading-normal ' + (openTab === 2 ? 'text-black border-blue-500 border-b-2' : 'text-black')}
											onClick={(e) => {
												e.preventDefault();
												setOpenTab(2);
											}}
											data-toggle='tab'
											href='#link2'
											role='tablist'>
											Edtech
										</a>
									</li>
								</ul>
								<div className='relative flex flex-col min-w-0 break-words bg-white w-full mb-6'>
									<div className='px-4 py-5 flex-auto'>
										<div className='tab-content tab-space text-center'>
											<div className={openTab === 1 ? 'block' : 'hidden'} id='link1'>
												<iframe
													src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14016.983781120016!2d77.28161903145399!3d28.56237646542076!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce3b37afd87c3%3A0x9a21a413c9f2c79e!2sGurucool%20Educenter!5e0!3m2!1sen!2sin!4v1645540353204!5m2!1sen!2sin'
													width='100%'
													height='450'
													allowFullScreen
													loading='lazy'></iframe>
											</div>
											<div className={openTab === 2 ? 'block' : 'hidden'} id='link2'>
												<iframe
													src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14016.983781120016!2d77.28161903145399!3d28.56237646542076!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce5abe284f5b3%3A0xa31a25fa932f681d!2sGuruCool!5e0!3m2!1sen!2sin!4v1645540409360!5m2!1sen!2sin'
													width='100%'
													height='450'
													allowFullScreen
													loading='lazy'></iframe>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</>
				</div>
			</section>
			<style global jsx>{`
				footer {
					display: none !important;
				}
			`}</style>
		</>
	);
};

export default ExploreLocation;
